import { render, staticRenderFns } from "./userDetail.vue?vue&type=template&id=344279f4&scoped=true&"
import script from "./userDetail.vue?vue&type=script&lang=js&"
export * from "./userDetail.vue?vue&type=script&lang=js&"
import style0 from "./userDetail.vue?vue&type=style&index=0&id=344279f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344279f4",
  null
  
)

export default component.exports